import * as React from 'react';
import Button from '@mui/material/Button';
import {Typography} from '@mui/material';
import {useEffect} from "react";
import {debounce} from "lodash";
import {CnipaConnectType, useCnipaConnect, useGlobalActions} from "@/store/global.c";
import CircleIcon from '@mui/icons-material/Circle';

type ResultConnectType = {
    code: number
    connect: CnipaConnectType
}
export const ConnectCnipa = () => {
    const cnipaConnect = useCnipaConnect()
    const {setCnipaConnect} = useGlobalActions()

    function retry(func: Function, maxRetry: number, timeout: number) {
        let retryCount = 0;
        let timer: NodeJS.Timeout;
        const run = () => {
            func();
            if (retryCount < maxRetry) {
                retryCount++;
                clearTimeout(timer);
                timer = setTimeout(run, timeout);
            }
        };
        timer = setTimeout(run, timeout);
    }

    const delayLoad = debounce(() => {
        retry(() => {
            window.postMessage({type: "CheckConnect"})
        }, 200000, 10000)
    }, 1000);

    useEffect(() => {
        delayLoad()
        window.addEventListener("message", listenerMessage)
        return () => {
            window.removeEventListener("message", listenerMessage)
        }
    }, []);

    const listenerMessage = (event: MessageEvent) => {
        if (event?.data?.type == 'ResultCheckConnect') {
            const result: ResultConnectType = event.data?.data
            if (result.code == 0) {
                setCnipaConnect({...result.connect, status: "SUCCESS"});
            } else {
                setCnipaConnect({...cnipaConnect, status: "FAIL"})
            }
        }
    }

    return (
        <Button variant={'outlined'} startIcon={<CircleIcon color={cnipaConnect.status == "SUCCESS" ? 'success' : "error"}/>} size={'medium'}>
            <Typography overflow={'hidden'}
                        textOverflow={'ellipsis'}
                        whiteSpace={'nowrap'}
                        maxWidth={180}>{cnipaConnect.status == 'SUCCESS' ? cnipaConnect.agencyName : "未连接到专利业务办理客户端"}</Typography>
        </Button>
    );
}
